import React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { ErrorBoundary } from '../errors/ErrorBoundary';

const MainLayout: React.FC = () => {
  const location = useLocation();

  const isActive = (path: string): boolean => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <ErrorBoundary>
      <div className="main-layout d-flex flex-column min-vh-100">
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark mb-4">
          <div className="container">
            <Link className="navbar-brand" to="/">ShitList Poll</Link>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav me-auto">
                <li className="nav-item">
                  <Link
                    className={`nav-link ${isActive('/officials') ? 'active' : ''}`}
                    to="/officials"
                  >
                    Officials
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${isActive('/acts') ? 'active' : ''}`}
                    to="/acts"
                  >
                    Acts
                  </Link>
                </li>
              </ul>
              <div className="navbar-nav">
                <Link
                  className={`nav-link ${isActive('/auth') ? 'active' : ''}`}
                  to="/auth/login"
                >
                  Login
                </Link>
              </div>
            </div>
          </div>
        </nav>

        <main className="container flex-grow-1">
          <Outlet />
        </main>

        <footer className="footer mt-5 py-3 bg-light">
          <div className="container text-center">
            <span className="text-muted">© {new Date().getFullYear()} ShitList Poll. All rights reserved.</span>
          </div>
        </footer>
      </div>
    </ErrorBoundary>
  );
};

export default MainLayout;